module.exports = __webpack_public_path__ + "static/media/hall-void.8fccb586.svg";